export const iconFontAwesomeHumanitarianPerson = (
	<i className="fa-solid fa-person"></i>
);
